var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestedit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.918 0.909281C18.6976 -0.311104 16.7191 -0.311115 15.4986 0.909281L13.7489 2.65907L5.51343 10.8944C5.37993 11.028 5.28523 11.1953 5.23944 11.3784L4.19777 15.5451C4.10902 15.9001 4.21303 16.2756 4.47176 16.5342C4.73049 16.793 5.106 16.897 5.46098 16.8083L9.6276 15.7666C9.81083 15.7208 9.97802 15.6261 10.1116 15.4926L18.2871 7.31711L20.0968 5.50742C21.3172 4.28703 21.3172 2.30838 20.0968 1.088L19.918 0.909281ZM16.9718 2.38242C17.3785 1.97562 18.0381 1.97562 18.4449 2.38242L18.6236 2.56113C19.0304 2.96794 19.0304 3.62749 18.6236 4.03428L17.5648 5.09316L15.9446 3.40962L16.9718 2.38242ZM15.9446 3.40962L17.5648 5.09316L8.8425 13.8155L6.63997 14.3661L7.19058 12.1636L15.9446 3.40962ZM2.08333 6.42271C2.08333 5.84742 2.54971 5.38104 3.125 5.38104H8.33333C8.90865 5.38104 9.375 4.91468 9.375 4.33937C9.375 3.76408 8.90865 3.29771 8.33333 3.29771H3.125C1.39911 3.29771 0 4.69682 0 6.42271V17.881C0 19.6069 1.39911 21.006 3.125 21.006H14.5833C16.3093 21.006 17.7083 19.6069 17.7083 17.881V12.6727C17.7083 12.0975 17.242 11.631 16.6667 11.631C16.0914 11.631 15.625 12.0975 15.625 12.6727V17.881C15.625 18.4563 15.1586 18.9227 14.5833 18.9227H3.125C2.54971 18.9227 2.08333 18.4563 2.08333 17.881V6.42271Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestedit);
export default __webpack_public_path__ + "static/media/testedit.3f5a7be2e3de4acb6eb884114f8407a4.svg";
export { ForwardRef as ReactComponent };